var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-button',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.text),expression:"text",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.copied),expression:"copied",arg:"success"}],attrs:{"color":"primary","icon":"icon-copy","icon-pack":"feather"}})
}
var staticRenderFns = []

export { render, staticRenderFns }